import { useEffect, useState } from 'react'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatment-right/treatment-right/style'

/** API */
import TreatmentRightApi from 'api/setting/treatment-right.api'
/** UTILS || SLICE */
import { showModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { useDispatch } from 'react-redux'
import { numberFormat, numberOnly } from 'utils/app.utils'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}
const initStateErrorMessage = {
  TREATMENT_RIGHT_CODE: ``,
  IS_DUPLICATE_TREATMENT_RIGHT_CODE: ``,
  TREATMENT_RIGHT_CODE_STRING_BASE: ``,
  TREATMENT_RIGHT_CODE_STRING_EMPTY: ``,
  TREATMENT_RIGHT_CODE_MAXIMUM_LENGTH: ``,
  TREATMENT_RIGHT_CODE_ANY_REQUIRED: ``,

  TREATMENT_RIGHT_NAME: ``,
  IS_DUPLICATE_TREATMENT_RIGHT_NAME: ``,
  TREATMENT_RIGHT_NAME_STRING_BASE: ``,
  TREATMENT_RIGHT_NAME_STRING_EMPTY: ``,
  TREATMENT_RIGHT_NAME_MAXIMUM_LENGTH: ``,
  TREATMENT_RIGHT_NAME_ANY_REQUIRED: ``,

  TREATMENT_RIGHT_NAME_EN: ``,
  IS_DUPLICATE_TREATMENT_RIGHT_NAME_EN: ``,
  TREATMENT_RIGHT_NAME_EN_STRING_BASE: ``,
  TREATMENT_RIGHT_NAME_EN_STRING_EMPTY: ``,
  TREATMENT_RIGHT_NAME_EN_MAXIMUM_LENGTH: ``,
  TREATMENT_RIGHT_NAME_EN_ANY_REQUIRED: ``,

  TREATMENT_RIGHT_PRICE: ``,
  TREATMENT_RIGHT_AMOUNT: ``
}


export default function TreatmentRight() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [treatmentRights, setTreatmentRights] = useState([])
  const [treatmentRightId, setTreatmentRightId] = useState(Number)
  const [treatmentRightCode, setTreatmentRightCode] = useState('')
  const [treatmentRightName, setTreatmentRightName] = useState('')
  const [treatmentRightStatus, setTreatmentRightStatus] = useState('')
  const [amount, setAmount] = useState<any>(1)
  const [price, setPrice] = useState<any>('')
  const [unit, setUnit] = useState('BAHT')
  const [isDivide, setIsDivide] = useState('0')
  const [isDoctorFee, setIsDoctorFee] = useState('0')
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpen, setIsOpen] = useState(false)

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  const loadData = async () => {
    try {
      const resp = await TreatmentRightApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTreatmentRights(resp.data)
      } else {
        setTreatmentRights([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!treatmentRightCode || !treatmentRightName || price === null || price === '0' || !price || amount === null || amount === 0 || amount === '0') {
      setDisabledSubmit(false)
      return setErrorMessage({
        ...errorMessage,
        ...{
          TREATMENT_RIGHT_CODE: !treatmentRightCode ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_CODE`) : '',
          TREATMENT_RIGHT_NAME: !treatmentRightName ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_NAME`) : '',
          TREATMENT_RIGHT_PRICE: price === null || !price || price === '0' ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_PRICE`) : '',
          TREATMENT_RIGHT_AMOUNT: amount === null || !amount || amount === '0' ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_AMOUNT`) : ''
        }
      })
    }
    TreatmentRightApi.create({ treatmentRightCode, treatmentRightName, treatmentRightNameEn: treatmentRightName, price, unit, amount, isDivide, isDoctorFee })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          setIsOpen(false)
          resetForm()
          loadData()
          notiSuccess(t('TREATMENT_RIGHT.MESSAGE.SUCCESS.CREATE'), '', null,)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_RIGHT.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_RIGHT.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!treatmentRightCode || !treatmentRightName || price === null || price === '0' || !price || amount === null || !amount || amount === '0') {
      setDisabledSubmit(false)
      return setErrorMessage({
        ...errorMessage,
        ...{
          TREATMENT_RIGHT_CODE: !treatmentRightCode ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_CODE`) : '',
          TREATMENT_RIGHT_NAME: !treatmentRightName ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_NAME`) : '',
          TREATMENT_RIGHT_PRICE: price === null || !price || price === '0' ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_PRICE`) : '',
          TREATMENT_RIGHT_AMOUNT: amount === null || !amount || amount === '0' ? t(`TREATMENT_RIGHT.MESSAGE.TREATMENT_RIGHT_AMOUNT`) : ''
        }
      })
    }

    TreatmentRightApi.update(treatmentRightId, { treatmentRightCode, treatmentRightName, treatmentRightNameEn: treatmentRightName, price, unit, amount, isDivide, isDoctorFee, status: treatmentRightStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          setIsOpen(false)
          resetForm()
          loadData()
          notiSuccess(t(`TREATMENT_RIGHT.MESSAGE.SUCCESS.UPDATE`), '', null, null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_RIGHT.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_RIGHT.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setIsOpen(false)
    setTreatmentRightId(0)
    setTreatmentRightCode('')
    setTreatmentRightName('')
    setAmount(1)
    setPrice('')
    setUnit('BAHT')
    setIsDoctorFee('0')
    setIsDivide('0')
    setTreatmentRightStatus('')
    clearErrorMessage()
  }

  const onActive = () => {
    if (id) {
      TreatmentRightApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_RIGHT.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_RIGHT.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onDelete = () => {
    if (id) {
      TreatmentRightApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_RIGHT.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_RIGHT.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { treatmentRightId: txRightId, treatmentRightCode: txRightCode, treatmentRightName: txRightName, price: txRightPrice, amount: txRightAmount, unit: txRightUnit, isDivide: txRightIsDivide, isDoctorFee: txRightIsDoctorFee, status: txRightStatus } = data
    setTreatmentRightCode(txRightCode)
    setTreatmentRightId(txRightId)
    setTreatmentRightName(txRightName)
    setPrice(txRightPrice)
    setAmount(txRightAmount)
    setUnit(txRightUnit)
    setIsDivide(txRightIsDivide)
    setIsDoctorFee(txRightIsDoctorFee)
    setTreatmentRightStatus(txRightStatus)
    dispatch(showModal())
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'treatmentRightCode', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.TREATMENT_RIGHT_CODE') },
    { id: 'treatmentRightName', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.TREATMENT_RIGHT_NAME') },
    { id: 'price', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.PRICE'), align: 'right' },
    { id: 'unit', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.UNIT'), align: 'center' },
    { id: 'amount', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.AMOUNT'), align: 'right' },
    { id: 'status', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('TREATMENT_RIGHT.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { treatmentRightId: txRightId, treatmentRightCode: txRightCode, treatmentRightName: txRightName, price: txRightPrice, unit: txRightUnit, amount: txRightAmount, updatedBy, updatedAt, status: txRightStatus } = objData

    const statusBtnActive = txRightStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = txRightStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: txRightId,
      id: txRightId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: txRightCode },
        { option: 'TEXT', align: 'left', label: txRightName },
        { option: 'TEXT', align: 'right', label: txRightUnit === 'BAHT' ? numberFormat(txRightPrice) : txRightPrice },
        { option: 'TEXT', align: 'right', label: txRightUnit === 'BAHT' ? t('CURRENCY_CHANGE.TH') : '%' },
        { option: 'TEXT', align: 'center', label: txRightAmount },
        { option: 'STATUS', align: 'center', label: txRightStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setIsOpenAlertModal(true)
    setStatusAlertModal(status)
    setId(obj.treatmentRightId)
    setName(obj.treatmentRightName)
    setNameEn(obj.treatmentRightNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TREATMENT_RIGHT.ALERT.TITLE_${statusAlertModal === 'DELETE' ? 'DELETE' : 'ACTIVE'}`)}
        message={t(`TREATMENT_RIGHT.ALERT.${statusAlertModal === "DELETE" ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentPlanTypeName: name, treatmentPlanTypeNameEn: nameEn ? `(${nameEn})` : nameEn, status: t(`TREATMENT_RIGHT.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={treatmentRightId ? t('TREATMENT_RIGHT.TITLE_UPDATE') : t('TREATMENT_RIGHT.TITLE_CREATE')}
        size='S'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('TREATMENT_RIGHT.BUTTON.CANCEL') }}
        onSubmit={{ onClick: treatmentRightId ? submitEdit : submit, title: t('TREATMENT_RIGHT.BUTTON.SAVE'), disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="24px">
          {treatmentRightId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('TREATMENT_RIGHT.TITLE_CREATE')}</Typography>
            <SwitchButton onChange={() => setTreatmentRightStatus(treatmentRightStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={treatmentRightStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setTreatmentRightCode(event.target.value)
              clearErrorMessage()
            }}
            fullWidth
            label={t('TREATMENT_RIGHT.INPUT.TREATMENT_RIGHT_CODE')}
            value={treatmentRightCode}
            helperText={
              errorMessage.TREATMENT_RIGHT_CODE ||
              errorMessage.IS_DUPLICATE_TREATMENT_RIGHT_CODE ||
              errorMessage.TREATMENT_RIGHT_CODE_STRING_BASE ||
              errorMessage.TREATMENT_RIGHT_CODE_STRING_EMPTY ||
              errorMessage.TREATMENT_RIGHT_CODE_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_RIGHT_CODE_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setTreatmentRightName(event.target.value)
              clearErrorMessage()
            }}
            value={treatmentRightName}
            helperText={
              errorMessage.TREATMENT_RIGHT_NAME ||
              errorMessage.IS_DUPLICATE_TREATMENT_RIGHT_NAME ||
              errorMessage.TREATMENT_RIGHT_NAME_STRING_BASE ||
              errorMessage.TREATMENT_RIGHT_NAME_STRING_EMPTY ||
              errorMessage.TREATMENT_RIGHT_NAME_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_RIGHT_NAME_ANY_REQUIRED
            }
            label={t('TREATMENT_RIGHT.INPUT.TREATMENT_RIGHT_NAME')}
            required
          />
          <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
            <TextInput
              onChange={(event) => {
                if (unit === 'PERCENT') {
                  if (Number(event.target.value) >= 100) {
                    setPrice('100')
                  } else {
                    setPrice(event.target.value)
                  }
                } else {
                  setPrice(event.target.value.replace(/[^0-9.]/g, ''))
                }
                clearErrorMessage()
              }}
              value={price}
              label={t('TREATMENT_RIGHT.INPUT.PRICE')}
              required
              numberOnly={unit === 'PERCENT' ? true : false}
              fullWidth
              helperText={errorMessage.TREATMENT_RIGHT_PRICE}
            />
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                setUnit(value)
                setIsDivide('0')
                setPrice('')
                // if (value) {
                //   if (value === 'PERCENT') {
                //     setIsDivide('0')
                //     setPrice(0)
                //   }
                //   // if (value === 'PERCENT' && price > 100) setPrice(100)
                //   setUnit(value)
                // }
              }}
              label={t('TREATMENT_RIGHT.INPUT.UNIT')}
              value={unit}
              options={[
                { value: 'BAHT', name: t('TREATMENT_RIGHT.UNIT.BATH') },
                { value: 'PERCENT', name: t('TREATMENT_RIGHT.UNIT.PERCENT') }
              ]}
            />
          </Box>
          <CheckboxButton
            checked={isDivide === '1' ? true : false}
            label={t('TREATMENT_RIGHT.INPUT.IS_DIVIDE')}
            disabled={unit === 'PERCENT'}
            onChange={(e) => {
              if (e.target.checked) setAmount(1)
              setIsDivide(e.target.checked === false ? '0' : '1')
            }}
          />
          <TextInput
            required
            disabled={isDivide === '1' ? true : false}
            inputProps={{ min: 0 }}
            onChange={(event) => {
              setAmount(numberOnly(event))
              clearErrorMessage()
            }}
            value={amount}
            label={t('TREATMENT_RIGHT.INPUT.AMOUNT')}
            helperText={errorMessage.TREATMENT_RIGHT_AMOUNT}
          />
          <CheckboxButton
            checked={isDoctorFee === '0' ? true : false}
            label={t('TREATMENT_RIGHT.INPUT.IS_DOCTOR_FEE')}
            onChange={(e) => setIsDoctorFee(e.target.checked ? '0' : '1')}
          />
        </Box>
      </PageModal>
      <HeaderCard text={t('TREATMENT_RIGHT.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TREATMENT_RIGHT.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton title={t('TREATMENT_RIGHT.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={treatmentRights.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
